import $http from '@/core/services/http.service';
import { ActionTree } from 'vuex';

import { State } from '@/manager/business/store/state';
import Endpoints from '@/constants/endpoints';
import UtilsService from '@/core/services/utils.service';

export interface Actions {
    fetchInternalBusinessList: {  };
}

export const actions: ActionTree<State, any> = {
    fetchInternalBusinessList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {};
            params = UtilsService.getQueryParams(payload);
            $http.get(`${Endpoints.internalBusiness}`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('setInternalBusinessList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    fetchProviderList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {};
            params = UtilsService.getQueryParams(payload);
            $http.get(`${Endpoints.provider}`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('setProviderList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
};
